module.exports = __webpack_public_path__ + "img/bg_1080x540.3b128f36.png";